import axios from 'axios'
import { Toast } from 'vant';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  baseURL: 'https://jhd.xhby.net/hlj',
  // baseURL: '/hlj',
  // timeout: 15000
  timeout: 300000
})

// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === true
  let _cookie = localStorage.getItem('cookie')
  if (_cookie) {
    // console.log(_cookie)
    config.headers['Authorization'] = _cookie // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  if(res.data.code == 401||res.data.code == 403){
    Toast(res.data.msg)
    // console.log(location)
    // location.href = '/#/login';
    // window.location = window.location.protocol+'//jshare.xhby.net/honglingjin/#/login'
    window.location = window.location.href.split('#')[0] + '/#/login'
    return
  }
  if(res.data.code == 500&&res.data.msg.indexOf('exp')!=-1){
    Toast('登录过期，请重新登录。')
    localStorage.clear()
    window.location = window.location.href.split('#')[0] + '/#/login'
    return
  }
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200;
  // 获取错误信息
  return res
},
  error => {
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js